export const siteInfo = {
  name: '婚姻边界指南',
  tagline: '妻子的朋友——你与她之间那道微妙的边界',
  description: '「妻子的朋友」是婚姻生活中一个敏感而真实的存在。本网站深度探讨如何与妻子的朋友建立健康得体的相处模式，维护婚姻边界感，避免误解与摩擦，帮助已婚男性在社交场合中做到自然、坦荡、让妻子放心。',
  keywords: '妻子的朋友,如何与妻子的朋友相处,已婚男性社交边界,婚姻中的异性友谊,妻子闺蜜相处技巧,夫妻社交边界感,婚姻关系维护',
  url: 'https://www.hunyinbianjie.com',
  author: '婚姻边界指南编辑部',
  foundedYear: '2024',
  email: 'contact@hunyinbianjie.com',
  wechat: 'hunyinbianjie',
  phone: '400-888-9999',
  address: '北京市朝阳区建国路88号',
  faqs: [
    {
      question: '已婚男性和妻子的朋友单独相处可以吗？',
      answer: '原则上应尽量避免单独相处的情境。如果确实无法避免，建议选择公共场所，提前告知妻子，并在见面后主动同步情况。这不是不信任，而是对婚姻的尊重。研究表明，大多数婚姻中的误会都源于"我以为没什么大不了"的独处场景。'
    },
    {
      question: '如果妻子的朋友主动向我倾诉感情问题怎么办？',
      answer: '适度倾听是可以的，但不应成为她的主要情感支持者。建议引导她去找你的妻子——她的真正朋友——进行交流。你可以说："这件事我可能帮不了你太多，但我老婆肯定能给你更好的建议。"这既保持了善意，也守住了边界。'
    },
    {
      question: '如何判断自己是否越过了婚姻的社交边界？',
      answer: '有三个关键的预警信号：第一，你在刻意对妻子隐瞒和某人的互动；第二，你开始期待和某人独处；第三，你和某人分享了不对妻子说的事情。三个信号中出现任何一个，都需要立即调整自己的行为。预防永远比补救容易。'
    },
    {
      question: '妻子因为我和她朋友互动而吃醋，是我的问题吗？',
      answer: '不一定是你的行为有问题，但你需要认真对待妻子的感受。吃醋往往不是因为"发生了什么事"，而是因为"缺乏安全感"。与其争论谁对谁错，不如主动增加透明度，让妻子感受到你的重视和优先。记住：在婚姻中，感受永远比事实更需要被优先处理。'
    },
    {
      question: '结婚后还能有异性朋友吗？',
      answer: '可以，但需要满足四个健康标准：配偶知情且认可、互动完全经得起第三方审视、不占据夫妻之间应有的情感空间、可以随时为了婚姻调整或停止这段友谊。如果对任何一个标准感到犹豫，说明这段友谊可能存在问题。'
    },
    {
      question: '这个网站是男性读者写的吗？',
      answer: '我们的内容团队由婚姻咨询师、心理学家和有丰富婚姻经验的撰稿人组成，包括男性和女性作者。我们力求从多角度、客观地探讨婚姻社交边界话题，帮助所有已婚人士建立更健康、更幸福的婚姻关系。'
    }
  ],
  testimonials: [
    {
      name: '张先生',
      age: '35岁，结婚8年',
      content: '这个网站让我意识到很多以前忽略的问题。以前总觉得只要自己没做亏心事就行，现在才明白边界感对妻子的安全感有多重要。现在我们的关系比以前更好了。',
      rating: 5
    },
    {
      name: '李女士',
      age: '32岁，结婚5年',
      content: '我是通过丈夫推荐来看这个网站的。说实话，看到他在认真学习这些内容，我真的很感动。他不是因为做错了什么才学，而是因为在乎我们的关系。这种主动让我觉得很安心。',
      rating: 5
    },
    {
      name: '王先生',
      age: '40岁，结婚12年',
      content: '之前因为和妻子闺蜜走得太近差点离婚。是这里的文章让我看清了很多事情，后来按照建议去做了调整，现在我们夫妻关系比之前十年都好。真心推荐给所有已婚男性。',
      rating: 5
    },
    {
      name: '陈女士',
      age: '28岁，结婚3年',
      content: '作为一个新婚妻子，我对丈夫的社交边界其实有挺多不安的，但不知道怎么开口说。这个网站给了我很好的沟通框架和语言，让我能和丈夫理性地讨论这个问题。',
      rating: 5
    }
  ],
  stats: [
    { label: '原创文章', value: '200+' },
    { label: '读者社区', value: '50,000+' },
    { label: '婚姻咨询', value: '3,000+' },
    { label: '满意度', value: '98%' }
  ]
};